import * as tslib_1 from "tslib";
import { DataProperty, DataType } from 'breeze-client';
import { BreezeService } from './core/breeze.service';
import { DataSet } from './core/helpers/data-set';
import { AlertsService } from './core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { EntityManagerService } from './entity-manager.service';
var BackendSettingsService = /** @class */ (function (_super) {
    tslib_1.__extends(BackendSettingsService, _super);
    function BackendSettingsService(alertsService, translateService, entityManagerService) {
        return _super.call(this, alertsService, translateService, entityManagerService) || this;
    }
    /**
    * Methode is part of Bootflow in app.module.ts
    */
    BackendSettingsService.prototype.bootInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var entityType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initialize('settings');
                        entityType = this.entityManager.metadataStore.getEntityType('Setting');
                        entityType.addProperty(new DataProperty({
                            dataType: DataType.DateTime,
                            isNullable: true,
                            name: 'AsDate',
                            nameOnServer: 'AsDate'
                        }));
                        entityType.addProperty(new DataProperty({
                            dataType: DataType.Int32,
                            isNullable: true,
                            name: 'AsInteger',
                            nameOnServer: 'AsInteger'
                        }));
                        return [4 /*yield*/, this.loadBackendSettings()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns whether the parameter is before the expiration date.
     * @param {(moment.Moment | Date)} date The parameter is checked for its expiration.§
     * @returns {boolean} A value indicating whether the date is expired.
     * @memberOf BackendSettingsService
     */
    BackendSettingsService.prototype.isExpired = function (date) {
        var test = moment(date);
        if (!test.isValid() || this.daysBeforeExpiration === undefined) {
            return false;
        }
        test = test.clone();
        return test.startOf('day').isBefore(moment().add(this.daysBeforeExpiration - 1, 'days'));
    };
    /**
     * Returns a value indicating whether the request is still on time to be sent.
     * @param {Entity} subject The subject task to be given to the receiver.
     * @param {Entity} target The task to be received by the sender, or NULL in case of a reassign.
     * @returns {boolean} A value indicating whether the request is not too late to be sent.
     * @memberOf SettingsService
     */
    BackendSettingsService.prototype.isOnTime = function (subject, target) {
        if (target === void 0) { target = null; }
        if (!subject) {
            return false;
        }
        var onTime = !this.isExpired(subject['Start']);
        if (target) {
            onTime = onTime && !this.isExpired(target['Start']);
        }
        return onTime;
    };
    /**
     * Returns a value indicating whether the request is still on time to be sent.
     * @param {Entity} subject The subject task to be given to the receiver.
     * @param {Entity} target The task to be received by the sender, or NULL in case of a reassign.
     * @returns {boolean} A value indicating whether the request is not too late to be sent.
     * @memberOf SettingsService
     */
    BackendSettingsService.prototype.isDayOnTime = function (subject, target) {
        if (!subject || this.daysBeforeExpiration === undefined) {
            return false;
        }
        var onTime = !this.isExpired(subject);
        if (target) {
            onTime = onTime && !this.isExpired(target);
        }
        return onTime;
    };
    /**
     * Loads back-end settings.
     * @private
     * @memberOf BackendSettingsService
     */
    BackendSettingsService.prototype.loadBackendSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataSet, queryResult;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataSet = new DataSet(this);
                        dataSet.sourceName = 'SettingItems';
                        return [4 /*yield*/, dataSet.load('Setting')];
                    case 1:
                        queryResult = _a.sent();
                        // Test if we have a result
                        if (!queryResult || !queryResult.results) {
                            throw new Error('Can not load the backend settings');
                        }
                        // Run through the settings
                        queryResult.results.forEach(function (settingResult) {
                            var label = settingResult['Label'].replace('APP.SETTINGS.', '').toLowerCase();
                            switch (label) {
                                case 'publishedtill':
                                    _this.publishedTill = moment(settingResult['Value']);
                                    break;
                                case 'availabilityclosedtill':
                                    _this.availabilityClosedTill = moment(settingResult['Value']);
                                    break;
                                case 'daysbeforeexpiration':
                                    _this.daysBeforeExpiration = parseInt(settingResult['Value']);
                                    break;
                                case 'daysbeforeresponse':
                                    _this.daysBeforeResponse = parseInt(settingResult['Value']);
                                    break;
                            }
                        });
                        if (this.publishedTill == null) {
                            throw new Error('PublishedTill backend setting is missing');
                        }
                        if (this.availabilityClosedTill == null) {
                            throw new Error('AvailabilityClosedTill backend setting is missing');
                        }
                        if (this.daysBeforeExpiration == null) {
                            throw new Error('DaysBeforeExpiration backend setting is missing');
                        }
                        if (this.daysBeforeResponse == null) {
                            throw new Error('DaysBeforeExpiration backend setting is missing');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return BackendSettingsService;
}(BreezeService));
export { BackendSettingsService };
